import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {
  @Output() storybookCategoryEvent = new EventEmitter<string>();
  constructor(
  ) { }

  changeStoryBookCategoryEvent(data: any) {
    this.storybookCategoryEvent.emit(data);
  }
}
